<template>
  <div class="input-file">
    <input
      type="file"
      ref="myFiles"
      :id="id"
      @change="processFile"
      :multiple="multiple"
      class="input-file--input">
    <label
      :for="id"
      class="input-file--label button-link el-link--default">
      {{ filesName }}
    </label>
    <span class="input-file__legend">{{ legend }}</span>
  </div>
</template>

<script>
export default {
  name: 'inputUpload',
  props: {
    text: {
      default: 'Select a file',
      type: String,
    },
    files: {
      default: () => [],
      type: [Array, FileList],
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    legend: {
      default: '',
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
  },
  computed: {
    filesName() {
      if (!this.files.length) {
        return this.text;
      }
      return this.files.length > 1
        ? `${this.$t('base.file')} : ${this.files[0].name}, ...`
        : `${this.$t('base.file')} : ${this.files[0].name}`;
    },
  },
  methods: {
    processFile() {
      this.$emit('update:files', this.$refs.myFiles.files);
    },
  },
};
</script>

<style scoped lang="scss">
  .input-file {
    position: relative;
    &--input {
      display: none;
    }
    &--files-name {
      margin: 0;
      text-transform: uppercase;
      display: inline-block;
      margin-left: 10px;
    }
    &__legend {
      margin-left: 10px;
    }
  }
</style>
